<template>
  <FormKit type="select" label="Division" v-model="modelValue" :options="divisions" />
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
import { divisions as divisionsList } from '~/lib/enums/divisions';
const props = withDefaults(
  defineProps<{
    modelValue: string;
    includeAllOption?: boolean;
  }>(),
  {
    includeAllOption: true,
  }
);
const divisions = ref(
  (props.includeAllOption ? [{ value: '', label: 'All' }] : []).concat(
    divisionsList.map((p) => ({ value: p.label, label: p.label }))
  )
);
const emit = defineEmits(['update:modelValue']);
const { modelValue } = useVModels(props, emit);
</script>
